import { getImgVerifyCodeApi } from "@/api/user";
import { ref } from "vue";

const showImgVerify = ref<boolean>(false);
const imgVerifyCodeUrl = ref<string>("");
const inputValue = ref<string>("");
const captcha_key = ref<string>("");
const timer = ref<number>(0);
const gapTime = ref<number>(60);

const getImgVerifyCode = async () => {
  gapTime.value = 60;
  try {
    const res: any = await getImgVerifyCodeApi();
    imgVerifyCodeUrl.value = res.captcha_image_content;
    captcha_key.value = res.captcha_key;
    timer.value = new Date().getTime();
    setInterval(() => {
      gapTime.value = Math.round(
        60 - (new Date().getTime() - timer.value) / 1000
      );
    }, 1000);
  } catch (e) {
    console.error(e);
  }
};
const openImgVerify = () => {
  showImgVerify.value = true;
  getImgVerifyCode();
};
const closeImgVerify = () => {
  showImgVerify.value = false;
};

export {
  inputValue,
  imgVerifyCodeUrl,
  showImgVerify,
  captcha_key,
  gapTime,
  openImgVerify,
  closeImgVerify,
  getImgVerifyCode,
};
